module.exports = __webpack_public_path__ + "static/c532775bc55754bb25beb7a876f8da72a7146bbdbc99ca7f740ba6bf28701c1b-1397d4e8760b1deb25490d98a70d3011.jpeg";